module.exports = __webpack_public_path__ + "media/images/icon_room_member-c6913edfa2de85a5f7b89920ba271050.svg";